import { axiosPost } from 'shared/api/axios'
import { getAllCustomData } from 'shared/components/App/Auth'
import { setCustomData } from 'shared/redux/actions'
import { setFilterRoleName } from 'redux/actions'
import Store from 'redux/Store'
import loadPages from 'utils/loadPages'
import { apiUrls } from 'consts'

interface submitFormProps {
  data: any
  setIsLoading: Function
  setErrorMsg: Function
}

const submitForm = async (props: submitFormProps) => {
  if (!props.data.customer) return

  props.setIsLoading(true)
  props.setErrorMsg('')

  try {
    const response: any = await axiosPost(
      `${apiUrls.customers}/${apiUrls.actionSelect}`,
      { customer_id: props.data.customer.id },
    )

    if (response?.status === 200 && response.data?.customer) {
      const allCustomData = getAllCustomData()
      allCustomData.customer = response.data.customer

      if (response.data?.filterRole) {
        allCustomData.filterRole = response.data.filterRole
        Store.dispatch(setFilterRoleName(response.data.filterRole.name ?? ''))
      }

      Store.dispatch(setCustomData(allCustomData))

      const customer = response.data.customer
      const pages = await loadPages({
        role: allCustomData.role,
        customer,
        loadFromServer: customer?.active === 1,
      })

      const page = pages.find((item: any) =>
        item?.path &&
        typeof item.path === 'string' &&
        item.path.length &&
        item?.roles &&
        item.roles.includes(allCustomData.role),
      )

      window.location.href = (page && typeof page.path === 'string') ? page.path : '/'
    } else {
      props.setErrorMsg('Failed to select customer. Please try again.')
    }
  } catch {
    props.setErrorMsg('An error occurred. Please try again.')
  } finally {
    props.setIsLoading(false)
  }
}

export default submitForm
